/*
 * metadata-change-navtext
 *
 * Checks for metadata per node, specifically for
 * keys to change the nav button texts.
 *
 * Author: Tim Bauwens
 * Copyright: Berkeley Bridge 2020
 */

import { has } from "$json/lib/functional";
import { getmetadata } from "$json/lib/getmetadata";

((doc, $) =>
  $(() => {
    let classes = ["bb-next", "bb-prior", "bb-skip", "bb-restart"];

    let originals = {};

    let tempClasses = {};

    let flagged = [];

    classes.forEach(cls => {
      let button = doc.querySelector(`.${cls}`);
      if (!button) {
        // Remove this class, the button doesn't exist.
        flagged.push(cls);
      } else {
        let affected = button.querySelector(".text");
        if (!affected) {
          // Remove this class, and warn the user the template is not supportive.
          flagged.push(cls);
          window.console &&
            window.console.warn(
              `Using metadata-change-navtext with a non-supporting template.
              Please wrap nav strings with <span class="text></span>"`,
              button
            );
        } else {
          originals[cls] = affected.innerText.trim();
        }
      }
    });

    classes = classes.filter(cls => !flagged.includes(cls));

    const reset = () => {
      // Reset strings to orig. values.
      classes.forEach(cls => {
        replace(cls, originals[cls], tempClasses[cls]);
      });
    };

    const replace = (cls, string, tempClass) => {
      doc.querySelectorAll(`.${cls}`).forEach(btn => {
        const textElt = btn.querySelector(".text");
        if (!textElt) return;
        textElt.innerText = string;
        if (!tempClass) return;
        const isRemoving = tempClass.startsWith("-");
        const targetClass = isRemoving ? tempClass.slice(1) : tempClass;

        try {
          // If it starts with '-', remove it. Otherwise, add it.
          btn.classList.toggle(targetClass, !isRemoving);

          // Update the state object
          if (isRemoving) {
            delete tempClasses[cls];
          } else {
            tempClasses[cls] = `-${targetClass}`;
          }
        } catch (e) {
          console.error(
            `Invalid class provided for ".${cls}": "${targetClass}". ` +
              `Check for spaces, dots, or illegal characters.`,
            e
          );
        }
      });
    };

    $(doc).on("bb:finalHandleData bb:willUpdate", (e, data) => {
      if (data && data.groups && data.groups.length) {
        reset();
        const groups = getmetadata(data).groups;
        let currentgroupid = data.groups.reduce(
          (id, group) => (group.current ? group.groupid : false),
          false
        );
        groups.forEach((group, id) => {
          if (id === currentgroupid) {
            classes.forEach(cls => {
              has(cls)(group) &&
                replace(
                  cls,
                  group[cls].split("|")[0],
                  group[cls].split("|")[1]
                );
            });
          }
        });
      }
    });
  }))(document, jQuery);
